module.exports = __webpack_public_path__ + "img/no_content.9e7bb4b2.svg";